/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2021-04-23 17:44:04
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoPreview\directive\trsPreviewContent.js
 * @Description: 设置预览页左右高度相等
 */
'use strict';

angular.module('trsPreviewContentModule', [])
    .directive('trsPreviewContent', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            link: function() {
                $timeout(function() {
                    var $father = $('.preview_content');
                    var $left = $father.find('.article');
                    var $right = $father.find('.preview_relatedInfo');
                    var leftHeight = $left.height();
                    $right.height(leftHeight); // fh
                    $left.resize(function(event) {
                        var leftHeight = $left.height();
                        $right.height(leftHeight);
                    });
                });
            }
        };
    }]);
